export const onlyNumbersRegexp = new RegExp("^[0-9]*$");
export const phoneNumberRegexp = new RegExp("^[0-9]*$");
